import { redirect } from 'redux-first-router';
import { isMobileDevice } from '../../utils/device';
import { ROUTE_MOBILE_LANDING } from '../modules/routing';

/**
 * Middleware to redirect mobile users to mobile landing page
 * for all authenticated routes (except the mobile landing page itself)
 */
const mobileRedirectMiddleware = (store) => (next) => (action) => {
  // Let the action pass through first
  const result = next(action);

  // Check if this is a location change action
  if (action.type && action.type.startsWith('route/')) {
    const state = store.getState();
    const { location, auth } = state;
    const routesMap = location.routesMap;
    const currentRoute = routesMap[action.type];

    // Check if:
    // 1. User is authenticated
    // 2. Current route requires auth
    // 3. User is on mobile
    // 4. Not already on mobile landing page
    // 5. Not on login/signup/otp pages (allow these on mobile)
    const isAuthenticated = auth.isAuthSuccessed;
    const requiresAuth = currentRoute?.requiresAuth;
    const isMobile = isMobileDevice();
    const isAlreadyOnMobileLanding = action.type === ROUTE_MOBILE_LANDING;
    const isAuthPage = action.type.includes('LOGIN') || 
                       action.type.includes('SIGNUP') || 
                       action.type.includes('OTP');

    if (isAuthenticated && requiresAuth && isMobile && !isAlreadyOnMobileLanding && !isAuthPage) {
      // Redirect to mobile landing page
      store.dispatch(
        redirect({
          type: ROUTE_MOBILE_LANDING,
        })
      );
    }
  }

  return result;
};

export default mobileRedirectMiddleware;

